    $("#password").focus();

    var form = $("form");

    $("#submitButton").click(function(e) {
        e.preventDefault();
        $(".alert").hide();

        $.each([ "input", "select" ], function (index, value) {
            $(value).filter("[required]:visible").each(function(ind, field){
                $(field).removeClass("form-missing");
                if ($(field).val() == "") {
                    $(field).addClass("form-missing");
                }
            })
        });

        if ($("#password")[0].value !== $("#repeatPassword")[0].value) {
            $("#repeatPassword")[0].focus();
            $("#repeatPassword_alert").show();
            return false;
        }

        // If any highlighted fields exist, show an error
        if ($(".form-missing").length > 0) {
            var options = { title: "Warning! Missing Data.", message: "Please add all required fields before submiting."};
            return false;
        } else if ($(".form-error").length > 0) {
            var options = { title: "Warning! Incorrect Data.", message: "Please fix all incorrect fields before submiting."};
            return false;
        }

        form.submit();
        return true;
    });